/**
 * Resub landing page countdown timer
 */
(function () {
    function pad(n) {
      return String(n).padStart(2, '0');
    }
  
    function bindModalClose(modal) {
      if (!modal) return;
      var closeBtn = modal.querySelector('.modal-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          modal.classList.remove('active');
        });
      }
      modal.addEventListener('click', function (event) {
        if (event.target === modal) modal.classList.remove('active');
      });
    }
  
    function initCountdown(root) {
      var deadline = root.getAttribute('data-deadline');
      var expiredModalId = root.getAttribute('data-expired-modal');
      if (!deadline) return;
  
      var daysEl = root.querySelector('#cd-days');
      var hoursEl = root.querySelector('#cd-hours');
      var minsEl = root.querySelector('#cd-mins');
      var secsEl = root.querySelector('#cd-secs');
      var expiredModal = expiredModalId ? document.getElementById(expiredModalId) : null;
      var expiredShown = false;
  
      if (expiredModal) bindModalClose(expiredModal);
  
      function tick() {
        var diff = new Date(deadline).getTime() - Date.now();
  
        if (diff <= 0) {
          root.style.display = 'none';
          if (expiredModal && !expiredShown) {
            expiredShown = true;
            expiredModal.classList.add('active');
          }
          clearInterval(interval);
          return;
        }
  
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
  
        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minsEl) minsEl.textContent = pad(mins);
        if (secsEl) secsEl.textContent = pad(secs);
      }
  
      tick();
      var interval = setInterval(tick, 1000);
    }
  
    function boot() {
      document.querySelectorAll('.countdown-big[data-deadline]').forEach(initCountdown);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();